export default __webpack_public_path__ + "static/media/WeatherDashboardImg.6c2533bd.png";